import _ from 'lodash';
import FiltersConstants from '../constants/FiltersConstants';

const OBJECT_FILTER_KEYS = ['margins', 'categories', 'amenities', 'stars', 'review', 'regions', 'neighborhoods'];

export const FILTER_PARAM_KEYS = [
    'max_distance', 'top_x', 'name_contains', 'max_price_per_night', 'min_price_per_night',
    'in_policy', 'preferred_hotels', 'availability', 'free_cancellation',
    ...OBJECT_FILTER_KEYS,
];

const DEFAULT_STARS = {
    5: true,
    4: true,
    3: true,
    2: true,
    1: false,
};

const DEFAULT_REVIEW = {
    [FiltersConstants.REVIEW_LEVELS.EXCELLENT]: true,
    [FiltersConstants.REVIEW_LEVELS.VERY_GOOD]: true,
    [FiltersConstants.REVIEW_LEVELS.GOOD]: true,
    [FiltersConstants.REVIEW_LEVELS.FAIR]: true,
    [FiltersConstants.REVIEW_LEVELS.POOR]: false,
    [FiltersConstants.REVIEW_LEVELS.UNRATED]: true,
};

const DEFAULT_CATEGORIES = {
    [FiltersConstants.CATEGORIES.HOTEL]: true,
    [FiltersConstants.CATEGORIES.APARTMENT]: false,
    [FiltersConstants.CATEGORIES.OTHER]: false,
};

const DEFAULT_MARGINS = {
    [FiltersConstants.MARGINS.ABSOLUTE]: false,
    [FiltersConstants.MARGINS.PERCENTAGE]: false,
    [FiltersConstants.MARGINS.SCORE]: false,
    [FiltersConstants.MARGINS.RECOMMENDED]: false,
    [FiltersConstants.MARGINS.TEN_PERCENT]: false,
    [FiltersConstants.MARGINS.TOP_FIFTY]: false,
};

const DEFAULT_REGIONS = {
    [FiltersConstants.REGIONS.HIGH_LEVEL_REGION]: false,
    [FiltersConstants.REGIONS.MULTI_CITY_VICINITY]: false,
    [FiltersConstants.REGIONS.CITY]: false,
    [FiltersConstants.REGIONS.NEIGHBORHOOD]: false,
};

const DEFAULT_AMENITIES = {
    [FiltersConstants.AMENITIES.BREAKFAST_INCLUDED]: false,
    [FiltersConstants.AMENITIES.FREE_WIFI]: false,
    [FiltersConstants.AMENITIES.PARKING]: false,
    [FiltersConstants.AMENITIES.AIRPORT_SHUTTLE]: false,
    [FiltersConstants.AMENITIES.FITNESS_CENTRE]: false,
    [FiltersConstants.AMENITIES.RESTAURANT]: false,
    [FiltersConstants.AMENITIES.MEETING_ROOM]: false,
    [FiltersConstants.AMENITIES.SWIMMING_POOL]: false,
    [FiltersConstants.AMENITIES.AIR_CONDITIONING]: false,
    [FiltersConstants.AMENITIES.ELECTRIC_VEHICLE_CHARGING_STATION]: false,
    [FiltersConstants.AMENITIES.ACCESSIBILITY]: false,
    [FiltersConstants.AMENITIES.PETS_ALLOWED]: false,
};

const OBJECT_FILTER_DEFAULTS = {
    margins: DEFAULT_MARGINS,
    categories: DEFAULT_CATEGORIES,
    amenities: DEFAULT_AMENITIES,
    stars: DEFAULT_STARS,
    review: DEFAULT_REVIEW,
    regions: DEFAULT_REGIONS,
};

function diffFromDefault(key, value) {
    if (key === 'neighborhoods') {
        return _.pickBy(value, (v) => v === false);
    }

    const defaults = OBJECT_FILTER_DEFAULTS[key];
    return _.pickBy(value, (v, k) => v !== (defaults[k] ?? false));
}

export function filtersToParams(filters) {
    const params = {};

    if (filters.max_distance) params.max_distance = String(filters.max_distance);
    if (filters.top_x) params.top_x = String(filters.top_x);
    if (filters.name_contains) params.name_contains = filters.name_contains;
    if (filters.max_price_per_night) params.max_price_per_night = String(filters.max_price_per_night);
    if (filters.min_price_per_night) params.min_price_per_night = String(filters.min_price_per_night);
    if (filters.in_policy) params.in_policy = 'true';
    if (filters.preferred_hotels) params.preferred_hotels = 'true';
    if (filters.availability === false) params.availability = 'false';
    if (filters.free_cancellation) params.free_cancellation = 'true';

    for (const key of OBJECT_FILTER_KEYS) {
        if (filters[key] != null) {
            const diff = diffFromDefault(key, filters[key]);
            if (!_.isEmpty(diff)) {
                params[key] = JSON.stringify(diff);
            }
        }
    }

    return params;
}

export function paramsToFilters(searchParams) {
    const filters = {};

    const max_distance = searchParams.get('max_distance');
    if (max_distance !== null) filters.max_distance = Number(max_distance);

    const top_x = searchParams.get('top_x');
    if (top_x !== null) filters.top_x = Number(top_x);

    const name_contains = searchParams.get('name_contains');
    if (name_contains !== null) filters.name_contains = name_contains;

    const max_price_per_night = searchParams.get('max_price_per_night');
    if (max_price_per_night !== null) filters.max_price_per_night = Number(max_price_per_night);

    const min_price_per_night = searchParams.get('min_price_per_night');
    if (min_price_per_night !== null) filters.min_price_per_night = Number(min_price_per_night);

    const in_policy = searchParams.get('in_policy');
    if (in_policy !== null) filters.in_policy = in_policy === 'true';

    const preferred_hotels = searchParams.get('preferred_hotels');
    if (preferred_hotels !== null) filters.preferred_hotels = preferred_hotels === 'true';

    const availability = searchParams.get('availability');
    if (availability !== null) filters.availability = availability !== 'false';

    const free_cancellation = searchParams.get('free_cancellation');
    if (free_cancellation !== null) filters.free_cancellation = free_cancellation === 'true';

    for (const key of OBJECT_FILTER_KEYS) {
        const raw = searchParams.get(key);
        if (raw !== null) {
            try {
                filters[key] = JSON.parse(raw);
            } catch {}
        }
    }

    return filters;
}
